<template>
  <div class="business">
    <MobileNav />
    <div class="info-wrap">
      <div class="info-title">
        <span>实验室</span>
      </div>
      <div class="list">
        <div><router-link to="/lab/photoFit" >照片合成</router-link></div>
        <div>
          <router-link to="/lab/stretching">拉伸图片</router-link>
        </div>
        <div>
          <router-link to="/lab/canvas">canvas签名</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MobileNav from "../MobileNav";
import { setUserInfo } from '@/js/utils'
export default {
  components: {
    MobileNav
  },
  data() {
    return {};
  },
  mounted() {
    
  },
  sockets: {
    connect: function() {
      var token = localStorage.getItem("jwt");
      if (token) {
        this.$socket.emit("authenticate", { token });
      }
    },
    authenticated: function(data) {
      var token = localStorage.getItem("jwt");
      this.$socket.emit("queryUser", token);
    },
    unauthorized: function(error) {
      console.log('unauthorizederror :>> ', error );
      if (error.message === 'jwt expired') {
        
      }
    },
    userInfo: function(data) {
      setUserInfo.call(this, data)
    },

  },
};
</script>

<style lang="less" scoped>
.business {
  padding-bottom: 20px;
  .tc {
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    float: right;
    width: 200px;
  }
  .info-wrap {
    display: flex;
    margin: 0 auto;
    width: 90vw;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding-top: 2vh;
    .info-title {
      text-align: center;
      span {
        display: inline-block;
        text-align: center;
        color: #fff;
        width: 80vw;
        font-size: 18px;
      }
      margin-bottom: 4vh;
      line-height: 5vh;
    }
    .list {
      width: 80vw;
      height: 70vh;
      position: relative;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      padding-top: 15vh;
      div {
        width: 100%;
        margin: 2vh 0;
        border-radius: 5vh;
        box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
          0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
        background: linear-gradient(
          to top right,
          #313a46 20%,
          #444e58 80%
        ); //正常
        a {
          color: #fff;
          text-decoration: none;
          font-size: 16px;
          display: inline-block;
          width: 100%;
          padding: 2vh 0;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/mobile/mobileLaboratory.vue